import "../styles/license.scss";
function LicenseAgreement() {
  return (
    <section id="license-page" className="hero-area text-black py-4">
      {/* Coming section */}
      <div id="license section" className="py-5 px-3">
        <div id="page_1">
          <div class="dclr"></div>
          <p class="p0 ft0">
            <nobr>End-User</nobr> License Agreement
          </p>
          <p class="p1 ft1">Last updated: January 7, 2022</p>
          <p class="p2 ft1">
            Please read this <nobr>End-User</nobr> License Agreement carefully
            before clicking the "I Agree" button, downloading or using
            ChurchPlan.
          </p>
          <p class="p3 ft2">Interpretation and Definitions</p>
          <p class="p4 ft3">Interpretation</p>
          <p class="p5 ft4">
            The words of which the initial letter is capitalized have meanings
            defined under the following conditions. The following definitions
            shall have the same meaning regardless of whether they appear in
            singular or in plural.
          </p>
          <p class="p6 ft3">Definitions</p>
          <p class="p7 ft1">
            For the purposes of this <nobr>End-User</nobr> License Agreement:
          </p>
          <p class="p8 ft5">
            Agreement means this <nobr>End-User</nobr> License Agreement that
            forms the entire agreement between You and the Company regarding the
            use of the Application. Application means the software program
            provided by the Company downloaded by You through an Application
            Store's account to a Device, named ChurchPlan Application Store
            means the digital distribution service operated and developed by
            Apple Inc. (Apple App Store) or Google Inc. (Google Play Store) by
            which the Application has been downloaded to your Device.
          </p>
          <p class="p9 ft5">
            Company (referred to as either "the Company", "We", "Us" or "Our" in
            this Agreement) refers to Apricot Systems, Ontario, Canada.
          </p>
          <p class="p10 ft4">
            Content refers to content such as text, images, or other information
            that can be posted, uploaded, linked to or otherwise made available
            by You, regardless of the form of that content.
          </p>
          <p class="p11 ft1">Country refers to: Ontario, Canada</p>
          <p class="p12 ft1">
            Device means any device that can access the Application such as a
            computer, a cellphone or a digital tablet.
          </p>
          <p class="p13 ft6">
            Family Sharing / Family Group permits You to share applications
            downloaded through the Application Store with other family members
            by allowing them to view and download each others' eligible
            Applications to their associated Devices.
          </p>
        </div>
        <div id="page_2">
          <div id="p2dimg1">
            <img
              src="data:image/png;base64,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"
              id="p2img1"
            />
          </div>

          <p class="p14 ft5">
            <nobr>Third-Party</nobr> Services means any services or content
            (including data, information, applications and other products
            services) provided by a <nobr>third-party</nobr> that may be
            displayed, included or made available by the Application.
          </p>
          <p class="p15 ft4">
            You means the individual accessing or using the Application or the
            company, or other legal entity on behalf of which such individual is
            accessing or using the Application, as applicable.
          </p>
          <p class="p16 ft2">Acknowledgment</p>
          <p class="p17 ft4">
            By clicking the "I Agree" button, downloading or using the
            Application, You are agreeing to be bound by the terms and
            conditions of this Agreement. If You do not agree to the terms of
            this Agreement, do not click on the "I Agree" button, do not
            download or do not use the Application.
          </p>
          <p class="p18 ft1">
            This Agreement is a legal document between You and the Company and
            it governs your use of the Application made available to You by the
            Company.
          </p>
          <p class="p19 ft6">
            This Agreement is between You and the Company only and not with the
            Application Store. Therefore, the Company is solely responsible for
            the Application and its content. Although the Application Store is
            not a party to this Agreement, it has the right to enforce it
            against You as a third party beneficiary relating to your use of the
            Application.
          </p>
          <p class="p20 ft4">
            Since the Application can be accessed and used by other users via,
            for example, Family Sharing / Family Group or volume purchasing, the
            use of the Application by those users is expressly subject to this
            Agreement.
          </p>
          <p class="p21 ft1">
            The Application is licensed, not sold, to You by the Company for use
            strictly in accordance with the terms of this Agreement.
          </p>
          <p class="p3 ft2">License</p>
          <p class="p4 ft3">Scope of License</p>
          <p class="p22 ft4">
            The Company grants You a revocable, <nobr>non-exclusive,</nobr>
            <nobr>non-transferable,</nobr> limited license to download, install
            and use the Application strictly in accordance with the terms of
            this Agreement.
          </p>
          <p class="p23 ft1">
            You may only use the Application on a Device that You own or control
            and as permitted by the Application Store's terms and conditions.
          </p>
          <p class="p24 ft7">
            The license that is granted to You by the Company is solely for your
            personal, non- commercial purposes strictly in accordance with the
            terms of this Agreement.
          </p>
        </div>
        <div id="page_3">
          <div id="p3dimg1">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkQAAAABCAIAAACwiCb7AAAAGUlEQVQ4jWP0b9zLMApGwSgYBaNgFAxlAACWkQGPGSNTjQAAAABJRU5ErkJggg=="
              id="p3img1"
            />
          </div>

          <p class="p25 ft3">License Restrictions</p>
          <p class="p26 ft1">
            You agree not to, and You will not permit others to:
          </p>
          <p class="p27 ft1">
            <span class="ft8"></span>
            <span class="ft9">
              Copy or use the Application for any purpose other than as
              permitted under the above section 'License'.
            </span>
          </p>
          <p class="p28 ft4">
            <span class="ft8"></span>
            <span class="ft10">
              Modify, make derivative works of, disassemble, decrypt, reverse
              compile or reverse engineer any part of the Application.
            </span>
          </p>
          <p class="p29 ft12">
            <span class="ft8"></span>
            <span class="ft11">
              Remove, alter or obscure any proprietary notice (including any
              notice of copyright or trademark) of the Company or its
              affiliates, partners, suppliers or the licensors of the
              Application.
            </span>
          </p>
          <p class="p30 ft2">Content</p>
          <p class="p4 ft3">Content Restrictions</p>
          <p class="p31 ft4">
            The Company is not responsible for the entries, information or
            content of the Application's users. You expressly understand and
            agree that You are solely responsible for the Content and for all
            activity that occurs under your account, whether done so by You or
            any third person using your account.
          </p>
          <p class="p32 ft6">
            You may not transmit any Content that is unlawful, offensive,
            upsetting, intended to disgust, threatening, libelous, defamatory,
            obscene or otherwise objectionable. Examples of such objectionable
            Content include, but are not limited to, the following:
          </p>
          <p class="p33 ft1">
            <span class="ft8"></span>
            <span class="ft9">Unlawful or promoting unlawful activity.</span>
          </p>
          <p class="p34 ft4">
            <span class="ft8"></span>
            <span class="ft10">Defamatory, discriminatory, or </span>
            <nobr>mean-spirited</nobr> content, including references or
            commentary about religion, race, sexual orientation, gender,
            national/ethnic origin, or other targeted groups.
          </p>
          <p class="p35 ft4">
            <span class="ft8"></span>
            <span class="ft10">
              Spam, machine generated content or randomly generated content,
              constituting unauthorized or unsolicited advertising, chain
              letters, any other form of unauthorized solicitation, or any form
              of lottery or gambling.
            </span>
          </p>
          <p class="p36 ft6">
            <span class="ft8"></span>
            <span class="ft13">
              Containing or installing any viruses, worms, malware, trojan
              horses, or other content that is designed or intended to disrupt,
              damage, or limit the functioning of any software, hardware or
              telecommunications equipment or to damage or obtain unauthorized
              access to any data or other information of a third person.
            </span>
          </p>
          <p class="p37 ft4">
            <span class="ft8"></span>
            <span class="ft10">
              Infringing on any proprietary rights of any party, including
              patent, trademark, trade secret, copyright, right of publicity or
              other rights.
            </span>
          </p>
          <p class="p38 ft4">
            <span class="ft8"></span>
            <span class="ft10">
              Impersonating any person or entity including the Company and its
              employees or representatives.
            </span>
          </p>
          <p class="p39 ft1">
            <span class="ft8"></span>
            <span class="ft9">Violating the privacy of any third person.</span>
          </p>
          <p class="p40 ft1">
            <span class="ft8"></span>
            <span class="ft9">False information and features.</span>
          </p>
          <p class="p41 ft7">
            The Company reserves the right, but not the obligation, to, in its
            sole discretion, determine whether or not any Content is appropriate
            and complies with this Agreement, refuse or
          </p>
        </div>
        <div id="page_4">
          <div id="p4dimg1">
            <img
              src="data:image/png;base64,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"
              id="p4img1"
            />
          </div>

          <div id="id4_1">
            <p class="p42 ft4">
              remove any Content. The Company further reserves the right to make
              formatting and edits and change the manner any Content. The
              Company can also limit or revoke the use of the Application if You
              post such objectionable Content.
            </p>
            <p class="p43 ft6">
              As the Company cannot control all content posted by users and/or
              third parties on the Application, you agree to use the Application
              at your own risk. You understand that by using the Application You
              may be exposed to content that You may find offensive, indecent,
              incorrect or objectionable, and You agree that under no
              circumstances will the Company be liable in any way for any
              content, including any errors or omissions in any content, or any
              loss or damage of any kind incurred as a result of your use of any
              content.
            </p>
            <p class="p44 ft2">Modifications to the Application</p>
            <p class="p45 ft4">
              The Company reserves the right to modify, suspend or discontinue,
              temporarily or permanently, the Application or any service to
              which it connects, with or without notice and without liability to
              You.
            </p>
            <p class="p46 ft3">Updates to the Application</p>
            <p class="p47 ft4">
              The Company may from time to time provide enhancements or
              improvements to the features/functionality of the Application,
              which may include patches, bug fixes, updates, upgrades and other
              modifications.
            </p>
            <p class="p48 ft6">
              Updates may modify or delete certain features and/or
              functionalities of the Application. You agree that the Company has
              no obligation to (i) provide any Updates, or (ii) continue to
              provide or enable any particular features and/or functionalities
              of the Application to You.
            </p>
            <p class="p49 ft4">
              You further agree that all updates or any other modifications will
              be (i) deemed to constitute an integral part of the Application,
              and (ii) subject to the terms and conditions of this Agreement.
            </p>
            <p class="p50 ft3">Maintenance and Support</p>
            <p class="p51 ft4">
              The Company does not provide any maintenance or support for the
              download and use of the Application. To the extent that any
              maintenance or support is required by applicable law, the Company,
              not the Application Store, shall be obligated to furnish any such
              maintenance or support.
            </p>
          </div>
          <div id="id4_2">
            <p class="p52 ft2">Intellectual Property</p>
          </div>
        </div>
        <div id="page_5">
          <div id="p5dimg1">
            <img
              src="data:image/png;base64,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"
              id="p5img1"
            />
          </div>

          <div id="id5_1">
            <p class="p53 ft4">
              The Application and its original content (excluding Content
              provided by You or other users), features and functionality are
              and will remain the exclusive property of the Company and its
              licensors.
            </p>
            <p class="p54 ft1">
              The Service is protected by copyright, trademark, and other laws
              of both the Country and foreign countries.
            </p>
            <p class="p55 ft1">
              Our trademarks and trade dress may not be used in connection with
              any product or service without the prior written consent of the
              Company.
            </p>
            <p class="p56 ft2">
              <nobr>Third-Party</nobr> Services
            </p>
            <p class="p57 ft4">
              The Application may display, include or make available
              <nobr>third-party</nobr> content (including data, information,
              applications and other products services) or provide links to
              <nobr>third-party</nobr> websites or services.
            </p>
            <p class="p58 ft12">
              You acknowledge and agree that the Company shall not be
              responsible for any <nobr>Third-party</nobr> Services, including
              their accuracy, completeness, timeliness, validity, copyright
              compliance, legality, decency, quality or any other aspect
              thereof. The Company does not assume and shall not have any
              liability or responsibility to You or any other person or entity
              for any <nobr>Third-party</nobr> Services.
            </p>
            <p class="p59 ft4">
              You must comply with applicable Third parties' Terms of agreement
              when using the Application. <nobr>Third-party</nobr> Services and
              links thereto are provided solely as a convenience to You and You
              access and use them entirely at your own risk and subject to such
              third parties' Terms and conditions.
            </p>
            <p class="p50 ft2">Privacy Policy</p>
            <p class="p60 ft1">
              The Company collects, stores, maintains, and shares information
              about You in accordance with Our Privacy Policy:
              <nobr>www.churchplan.org/privacy-policy</nobr>
            </p>
            <p class="p61 ft1">
              By accepting this Agreement, You acknowledge that You hereby agree
              and consent to the terms and conditions of Our Privacy Policy.
            </p>
            <p class="p50 ft2">Term and Termination</p>
          </div>
          <div id="id5_2">
            <p class="p52 ft6">
              This Agreement shall remain in effect until terminated by You or
              the Company. The Company may, in its sole discretion, at any time
              and for any or no reason, suspend or terminate this Agreement with
              or without prior notice.
            </p>
          </div>
        </div>
        <div id="page_6">
          <div id="p6dimg1">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkQAAAC3CAIAAAB8G9aTAAAC3UlEQVR4nO3XQQ2EQAAEQSD44ywdvsDaImIfm06qFMyvM/v1fzYAKDtWDwCAWfsYY/UGAJjimQGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHnn735XbwCAKR88/weJHwxevgAAAABJRU5ErkJggg=="
              id="p6img1"
            />
          </div>

          <p class="p62 ft4">
            This Agreement will terminate immediately, without prior notice from
            the Company, in the event that you fail to comply with any provision
            of this Agreement. You may also terminate this Agreement by deleting
            the Application and all copies thereof from your Device or from your
            computer.
          </p>
          <p class="p63 ft1">
            Upon termination of this Agreement, You shall cease all use of the
            Application and delete all copies of the Application from your
            Device.
          </p>
          <p class="p64 ft4">
            Termination of this Agreement will not limit any of the Company's
            rights or remedies at law or in equity in case of breach by You
            (during the term of this Agreement) of any of your obligations under
            the present Agreement.
          </p>
          <p class="p16 ft2">Indemnification</p>
          <p class="p65 ft4">
            You agree to indemnify and hold the Company and its parents,
            subsidiaries, affiliates, officers, employees, agents, partners and
            licensors (if any) harmless from any claim or demand, including
            reasonable attorneys' fees, due to or arising out of your: (a) use
            of the Application; (b) violation of this Agreement or any law or
            regulation; or (c) violation of any right of a third party.
          </p>
          <p class="p3 ft2">No Warranties</p>
          <p class="p66 ft6">
            The Application is provided to You "AS IS" and "AS AVAILABLE" and
            with all faults and defects without warranty of any kind. To the
            maximum extent permitted under applicable law, the Company, on its
            own behalf and on behalf of its affiliates and its and their
            respective licensors and service providers, expressly disclaims all
            warranties, whether express, implied, statutory or otherwise, with
            respect to the Application, including all implied warranties of
            merchantability, fitness for a particular purpose, title and non-
            infringement, and warranties that may arise out of course of
            dealing, course of performance, usage or trade practice. Without
            limitation to the foregoing, the Company provides no warranty or
            undertaking, and makes no representation of any kind that the
            Application will meet your requirements, achieve any intended
            results, be compatible or work with any other software,
            applications, systems or services, operate without interruption,
            meet any performance or reliability standards or be error free or
            that any errors or defects can or will be corrected.
          </p>
          <p class="p67 ft6">
            Without limiting the foregoing, neither the Company nor any of the
            company's provider makes any representation or warranty of any kind,
            express or implied: (i) as to the operation or availability of the
            Application, or the information, content, and materials or products
            included thereon; (ii) that the Application will be uninterrupted or
            <nobr>error-free;</nobr> (iii) as to the accuracy, reliability, or
            currency of any information or content provided through the
            Application; or (iv) that the Application, its servers, the content,
            or
            <nobr>e-mails</nobr> sent from or
          </p>
        </div>
        <div id="page_7">
          <div id="p7dimg1">
            <img
              src="data:image/png;base64,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"
              id="p7img1"
            />
          </div>

          <div id="id7_1">
            <p class="p68 ft1">
              on behalf of the Company are free of viruses, scripts, trojan
              horses, worms, malware, timebombs or other harmful components.
            </p>
            <p class="p69 ft6">
              Some jurisdictions do not allow the exclusion of certain types of
              warranties or limitations on applicable statutory rights of a
              consumer, so some or all of the above exclusions and limitations
              may not apply to You. But in such a case the exclusions and
              limitations set forth in this section shall be applied to the
              greatest extent enforceable under applicable law. To the extent
              any warranty exists under law that cannot be disclaimed, the
              Company, not the Application Store, shall be solely responsible
              for such warranty.
            </p>
            <p class="p44 ft2">Limitation of Liability</p>
            <p class="p45 ft4">
              Notwithstanding any damages that You might incur, the entire
              liability of the Company and any of its suppliers under any
              provision of this Agreement and your exclusive remedy for all of
              the foregoing shall be limited to the amount actually paid by You
              for the Application or through the Application or 100 USD if You
              haven't purchased anything through the Application.
            </p>
            <p class="p70 ft6">
              To the maximum extent permitted by applicable law, in no event
              shall the Company or its suppliers be liable for any special,
              incidental, indirect, or consequential damages whatsoever
              (including, but not limited to, damages for loss of profits, loss
              of data or other information, for business interruption, for
              personal injury, loss of privacy arising out of or in any way
              related to the use of or inability to use the Application,{" "}
              <nobr>third-party</nobr> software and/or <nobr>third-party</nobr>{" "}
              hardware used with the Application, or otherwise in connection
              with any provision of this Agreement), even if the Company or any
              supplier has been advised of the possibility of such damages and
              even if the remedy fails of its essential purpose.
            </p>
            <p class="p71 ft7">
              Some states/jurisdictions do not allow the exclusion or limitation
              of incidental or consequential damages, so the above limitation or
              exclusion may not apply to You.
            </p>
            <p class="p72 ft12">
              You expressly understand and agree that the Application Store, its
              subsidiaries and affiliates, and its licensors shall not be liable
              to You under any theory of liability for any direct, indirect,
              incidental, special consequential or exemplary damages that may be
              incurred by You, including any loss of data, whether or not the
              Application Store or its representatives have been advised of or
              should have been aware of the possibility of any such losses
              arising.
            </p>
            <p class="p73 ft2">Severability and Waiver</p>
            <p class="p74 ft3">Severability</p>
          </div>
          <div id="id7_2">
            <p class="p52 ft7">
              If any provision of this Agreement is held to be unenforceable or
              invalid, such provision will be changed and interpreted to
              accomplish the objectives of such provision to the greatest
            </p>
          </div>
        </div>
        <div id="page_8">
          <div id="p8dimg1">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkQAAAFsCAIAAACilTHLAAAFjUlEQVR4nO3XwQ3CQBAEQYycH04J54VTW4K4x6mlqgjm15rj8/29AKDsvXsAAKw6Zmb3BgBY4pkBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSJGQB5YgZAnpgBkCdmAOSd1/3s3gAASzwzAPKOmdm9AQCWeGYA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkDeed3P7g0AsOQPIMENgcwxZdwAAAAASUVORK5CYII="
              id="p8img1"
            />
          </div>

          <p class="p75 ft1">
            extent possible under applicable law and the remaining provisions
            will continue in full force and effect.
          </p>
          <p class="p3 ft3">Waiver</p>
          <p class="p76 ft6">
            Except as provided herein, the failure to exercise a right or to
            require performance of an obligation under this Agreement shall not
            effect a party's ability to exercise such right or require such
            performance at any time thereafter nor shall be the waiver of a
            breach constitute a waiver of any subsequent breach.
          </p>
          <p class="p77 ft2">Product Claims</p>
          <p class="p78 ft6">
            The Company does not make any warranties concerning the Application.
            To the extent You have any claim arising from or relating to your
            use of the Application, the Company, not the Application Store, is
            responsible for addressing any such claims, which may include, but
            not limited to: (i) any product liability claims; (ii) any claim
            that the Application fails to conform to any applicable legal or
            regulatory requirement; and (iii) any claim arising under consumer
            protection, or similar legislation.
          </p>
          <p class="p33 ft2">United States Legal Compliance</p>
          <p class="p79 ft6">
            You represent and warrant that (i) You are not located in a country
            that is subject to the United States government embargo, or that has
            been designated by the United States government as a "terrorist
            supporting" country, and (ii) You are not listed on any United
            States government list of prohibited or restricted parties.
          </p>
          <p class="p33 ft2">Changes to this Agreement</p>
          <p class="p80 ft4">
            The Company reserves the right, at its sole discretion, to modify or
            replace this Agreement at any time. If a revision is material, we
            will provide at least 30 days' notice prior to any new terms taking
            effect. What constitutes a material change will be determined at the
            sole discretion of the Company.
          </p>
          <p class="p81 ft4">
            By continuing to access or use the Application after any revisions
            become effective, You agree to be bound by the revised terms. If You
            do not agree to the new terms, You are no longer authorized to use
            the Application.
          </p>
        </div>
        <div id="page_9">
          <div id="p9dimg1">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAkQAAAFlCAIAAACFmmADAAAFcklEQVR4nO3XwQ3CQBAEQYycH04J54VTW4K4x6mlqgjm15rj8/29AKDsmJndGwBgyXv3AABYJWYA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHliBkCemAGQJ2YA5IkZAHnndT+7NwDAEs8MgLxjZnZvAIAlnhkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkiRkAeWIGQJ6YAZAnZgDkndf97N4AAEv+QwINc+KFe7gAAAAASUVORK5CYII="
              id="p9img1"
            />
          </div>

          <div id="id9_1">
            <p class="p52 ft2">Governing Law</p>
            <p class="p45 ft4">
              The laws of the Country, excluding its conflicts of law rules,
              shall govern this Agreement and your use of the Application. Your
              use of the Application may also be subject to other local, state,
              national, or international laws.
            </p>
            <p class="p50 ft2">Entire Agreement</p>
            <p class="p82 ft4">
              The Agreement constitutes the entire agreement between You and the
              Company regarding your use of the Application and supersedes all
              prior and contemporaneous written or oral agreements between You
              and the Company.
            </p>
            <p class="p83 ft4">
              You may be subject to additional terms and conditions that apply
              when You use or purchase other Company's services, which the
              Company will provide to You at the time of such use or purchase.
            </p>
            <p class="p50 ft2">Contact Us</p>
            <p class="p74 ft1">
              If you have any questions about this Agreement, You can contact
              Us:
            </p>
            <p class="p84 ft1">By email: support@churchplan.org</p>
            <p class="p85 ft1">
              By visiting this page on our website:
              http://www.churchplan.org/contact
            </p>
          </div>
          <div id="id9_2">
            <p class="p52 ft15">
              All rights reserved. 2022 Church<span class="ft14">Plan</span>®
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default LicenseAgreement;
